/**
 * The hidden message Pieve receives when the person dismisses a connection card (kept from the earlier
 * frontend). The wording matters: it must not read as "the connection was removed". Dismissing only
 * closes the prompt; an earlier wording ("Dismissed <App> connection.") made the agent believe a
 * working app had been disconnected and loop on reconnect prompts.
 */
const buildConnectionDismissSummary = ({ appName, isReconnect } = {}) => {
  const name = String(appName || '').trim() || 'app';
  const promptKind = isReconnect ? 'reconnection' : 'connection';

  return `Dismissed the ${name} ${promptKind} prompt without making any connection changes.`;
};

export default buildConnectionDismissSummary;
